import { useState } from 'react';
import { AudioPlayerRefContext } from './Context';
import type { AudioPlayer } from './interfaces';
import { AudioPlayerState } from './State';

type Props = {
  children: React.ReactNode;
  defaultMetadata?: AudioPlayer.Metadata;
};

const AudioPlayerContainer = (props: Props) => {

  const [ref, setRef] = useState<HTMLAudioElement>();

  return (
    <AudioPlayerState defaultMetadata={props.defaultMetadata}>
      <AudioPlayerRefContext.Provider value={[ref, setRef]}>
        {props.children}
      </AudioPlayerRefContext.Provider>
    </AudioPlayerState>
  );
};

export { AudioPlayerContainer };
export default AudioPlayerContainer;